import React from "react";
import styled from "styled-components";

const Card = (props) => {
  return (
    <Container>
      {/* <img src={props.img} alt={props.title} /> */}
      <CardBody>
        <CardText>
          <h2 className="card_title">{props.title}</h2>
          <p className="card_description">{props.description}</p>
          <p className="technologies">{props.technologies}</p>
          <p className="technologies2">{props.technologies2}</p>
        </CardText>
        <ButtonArea>
          {props.link_one ? (
            <a className="link1" href={props.link_one}>
              {props.link_one_text}
            </a>
          ) : null}
          {/* {props.link_two ? (
            <a className="link2" href={props.link_two}>
              {props.link_two_text}
            </a>
          ) : null}
          {props.link_three ? (
            <a className="link3" href={props.link_three}>
              {props.link_three_text}
            </a>
          ) : null} */}
        </ButtonArea>
      </CardBody>
    </Container>
  );
};

const Container = styled.div`
  opacity: 0.8;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.3);
  text-align: left;
  border-radius: 0.5rem;
  height: 18rem;
  width: 18rem;
  position: relative;
  overflow: hidden;
  /* border: solid 1px #fff; */
  background: #000000;
  img {
    width: 100%;
    display: block;
    /* border-bottom: 1px solid #fff; */
  }

  h2 {
    opacity: 0.8;
    font-size: 2.3rem;
    letter-spacing: 0.1rem;
  }

  .card_description {
    opacity: 0.8;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    font-style: italic;
    color: #ed6a5a;
  }

  .technologies {
    font-size: 0.8rem;
  }
  .technologies2 {
    font-size: 0.8rem;
  }

  a {
    opacity: 0.8;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    padding: 0.4rem;
    text-decoration: none;
    background-color: #000000;
    border: solid 1px #ed6a5a;
    color: white;
    border-radius: 10px;
    /* box-shadow: 0 5px 20px rgba(255, 255, 255, 0.3); */

    &:hover {
      background-color: #ed6a5a;
      color: #fff;
      border: 1px solid #ed6a5a;
    }
  }
`;

const CardText = styled.div`
  padding: 0.8rem 1rem 0rem 1rem;
`;

const CardBody = styled.div`
  height: calc(100% - 14rem - 1px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ButtonArea = styled.div`
  display: grid;
  padding: 1.5rem 1rem 1rem 1rem;
  padding-top: 1rem;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 0.5rem;
  .link1 {
    width: 7rem;
    height: 2.2rem;
    justify-content: center;
    grid-area: github;
  }
  /* .link2 {
    grid-area: website;
  }
  .link3 {
    grid-area: internal;
  } */
`;
export default Card;
